<template>
  <div>
    <faq>
      <router-view/>
    </faq>
  </div>
</template>

<script>
import Faq from '../../../components/faq/faq'
export default {
  name: 'FaqView',
  components: {
    Faq
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/faq/faq.view.vue